module.exports = __webpack_public_path__ + "static/poster_tb_en-59ee17c41646f4303263948c1590df4b.png";